import { Spinner, Center } from '@chakra-ui/react';

const Loading = () => {
  return (
    <Center>
      <Spinner size="md" />
    </Center>
  );
};

export default Loading;
